const FENCED_CODE_SEGMENT_PATTERN = /(```[\s\S]*?(?:```|$))/;
const INLINE_CODE_SEGMENT_PATTERN = /(`[^`\n]+`)/;

const LATEX_SYMBOLS: Readonly<Record<string, string>> = {
  rightarrow: "→",
  longrightarrow: "→",
  leftarrow: "←",
  longleftarrow: "←",
  Rightarrow: "⇒",
  Longrightarrow: "⇒",
  Leftarrow: "⇐",
  Longleftarrow: "⇐",
  leftrightarrow: "↔",
  Leftrightarrow: "⇔",
  mapsto: "↦",
  to: "→",
  gets: "←",
  times: "×",
  cdot: "·",
  pm: "±",
  mp: "∓",
  leq: "≤",
  le: "≤",
  geq: "≥",
  ge: "≥",
  neq: "≠",
  ne: "≠",
  approx: "≈",
  equiv: "≡",
  infty: "∞",
  cdots: "…",
  ldots: "…",
  dots: "…",
  checkmark: "✓",
  bullet: "•",
  degree: "°",
  alpha: "α",
  beta: "β",
  gamma: "γ",
  delta: "δ",
  epsilon: "ε",
  theta: "θ",
  lambda: "λ",
  mu: "μ",
  pi: "π",
  sigma: "σ",
  tau: "τ",
  phi: "φ",
  omega: "ω",
  Alpha: "Α",
  Beta: "Β",
  Gamma: "Γ",
  Delta: "Δ",
  Theta: "Θ",
  Lambda: "Λ",
  Pi: "Π",
  Sigma: "Σ",
  Phi: "Φ",
  Omega: "Ω",
};

function looksLikeCurrency(inner: string): boolean {
  const trimmed = inner.trim();
  return trimmed.length > 0 && !trimmed.includes("\\") && /^\d/.test(trimmed);
}

function replaceLatexCommands(body: string): string {
  let result = body.replace(/\\(?:text|mathrm)\{([^}]*)\}/g, "$1");
  result = result.replace(
    /\\([a-zA-Z]+)/g,
    (match, command: string) => LATEX_SYMBOLS[command] ?? match,
  );
  result = result.replace(/\\[,;:! ]/g, " ");
  result = result.replace(/[{}]/g, "");
  return result.trim();
}

function replaceDelimitedLatex(segment: string): string {
  let result = segment;

  result = result.replace(/\$\$([\s\S]+?)\$\$/g, (_, inner: string) => replaceLatexCommands(inner));
  result = result.replace(/\\\[(.+?)\\\]/g, (_, inner: string) => replaceLatexCommands(inner));
  result = result.replace(/(?<!\\)\$(?!\$)([^$\n]+?)(?<!\\)\$(?!\$)/g, (match, inner: string) =>
    looksLikeCurrency(inner) ? match : replaceLatexCommands(inner),
  );
  result = result.replace(/\\\((.+?)\\\)/g, (_, inner: string) => replaceLatexCommands(inner));

  return result;
}

function replaceOutsideInlineCode(segment: string): string {
  const parts = segment.split(INLINE_CODE_SEGMENT_PATTERN);
  return parts
    .map((part, index) => (index % 2 === 0 ? replaceDelimitedLatex(part) : part))
    .join("");
}

/** Turn common agent-authored `$\\rightarrow$`-style inline LaTeX into Unicode symbols for chat markdown. */
export function normalizeMarkdownInlineLatex(markdown: string): string {
  const segments = markdown.split(FENCED_CODE_SEGMENT_PATTERN);
  return segments
    .map((segment, index) => (index % 2 === 0 ? replaceOutsideInlineCode(segment) : segment))
    .join("");
}
